import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "react-credit-cards/es/styles-compiled.css";
import { ToastContainer } from 'react-toastify';

import LoadingSpinner from './service/loaders/LoadingSpinner';
import NavBar from 'components/NavBarLog/Navbar'; // 👈 importa tu Navbar

const TermConditions = lazy(() => import('./page/TermConditions/TermConditions'));
const MyTicket = lazy(() => import('./page/MyTickets/MyTicket'));
const Login = lazy(() => import('./page/Login/Login'));
const Home = lazy(() => import('./page/Home/Home'));
const Register = lazy(() => import('./page/Register/Register'));
const EventDetail = lazy(() => import('./friends-family/pages/EventDetailWithoutValidation'));
const Payment = lazy(() => import('./page/Payment/Payment'));
const Custom404 = lazy(() => import('./page/404/404'));
const Calendar = lazy(() => import('./page/Calendar/Calendar'));
const Announce = lazy(() => import('./page/Announce/Announce'));

interface Props {
  children?: React.ReactNode;
}

const Render = (props: Props) => (
  <Suspense fallback={<LoadingSpinner />}>
    {props.children}
  </Suspense>
);

// ✅ Layout contenedor que controla la visibilidad del NavBar
const LayoutWithNavBar = () => {
  const location = useLocation();

  // rutas donde NO debe mostrarse el Navbar
  const hideNavbarOn = ["/term-conditions"];
  const shouldShowNavbar = !hideNavbarOn.includes(location.pathname);

  return (
    <>
      {shouldShowNavbar && <NavBar showButtons={true} />}
      <Routes>
        <Route path="/" element={<Render children={<Home />} />} />
        <Route path="home" element={<Render children={<Home />} />} />
        <Route path="login" element={<Render children={<Login />} />} />
        <Route path="register" element={<Render children={<Register />} />} />
        <Route path="*" element={<Render children={<Custom404 />} />} />
        <Route path="/event/eventDetail/:id" element={<Render children={<EventDetail />} />} />
        <Route path="/my-tickets" element={<Render children={<MyTicket />} />} />
        <Route path="/term-conditions" element={<Render children={<TermConditions />} />} />
        <Route path="/calendar" element={<Render children={<Calendar />} />} />
      </Routes>
    </>
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <LayoutWithNavBar />
      <ToastContainer />
    </BrowserRouter>
  );
};

export default App;
